import errors from './errors';
import themes from './theme';
import features from './features';
import common from '../common';
import { CAI_MATERIAL } from '@cai/material';

export default {
  ...common,
  mobileTicket: 'Bilet mobil',
  ...features,
  save: 'Salvează',
  username: 'Nume utilizator',
  password: 'Parolă',
  login: 'Autentificare',
  required: 'Obligatoriu',
  light: 'Deschis',
  dark: 'Întunecat',
  rememberMe: 'Ține-mă minte',
  eula: 'EULA',
  copyright: '© {year} - Command Alkon, Inc.',
  termsAndConditions: 'Termeni și condiții',
  privacyPolicy: 'Politica de confidențialitate',
  customer: 'Client',
  project: 'Proiect',
  isBillable: 'Facturabil',
  dispatchDateTime: 'Data',
  orderId: 'Comandă',
  ticketId: 'Bilet',
  location: 'Locație',
  vehicleTypeName: 'Vehicul',
  product: 'Produs',
  products: 'Produs',
  salesTax: 'Taxă pe vânzări',
  totalPrice: 'Total',
  extendedPrice: 'Ext',
  destination: 'Destinație',
  productId: 'Produs',
  statusCode: 'Status',
  vehicleTypeId: 'ID tip vehicul',
  locationId: 'ID locație',
  customerId: 'ID client',
  projectId: 'ID proiect',
  dispatchTime: 'Oră',
  showAll: 'Afișează tot',
  hideAll: 'Ascunde tot',
  undoChanges: 'Anulare modificări',
  resetColumns: 'Resetare coloane',
  displayRowCount: `Afișare {count, plural, 
    =0 {0 rânduri}
    one {# rând}
    other {# rânduri}
  }`,
  columnFilters: 'Filtre coloane',
  visible: 'Vizibil',
  hidden: 'Ascuns',
  itemDetail: 'Detalii articol',
  quantity: 'Cantitate',
  quantityMaxWaterToAdd: 'Cantitate (Apă max. de adăugat: {maxWaterQuantity})',
  unloadingMethod: 'Metodă de descărcare',
  time: 'Ora',
  eventStatus: 'Status',
  MTQ_abbr: 'm\u00B3',
  EA_abbr: 'ea',
  LTR_abbr: 'L',
  YDQ_abbr: 'y³',
  GLL_abbr: 'gal',
  MTQ_text: 'Metri cubi',
  M3_text: 'Metri cubi',
  EA_text: 'Bucată',
  LTR_text: 'Litri',
  YDQ_text: 'Yarzi cubi',
  GLL_text: 'Galoni',
  ACR_text: 'Acri',
  HUR_text: 'Oră',
  INH_text: 'Țoli',
  FOT_text: 'Picior',
  YRD_text: 'Yard',
  MMT_text: 'Milimetru',
  CMT_text: 'Centimetru',
  MTR_text: 'Metru',
  SMI_text: 'Mile (milă statute)',
  KMT_text: 'Kilometru',
  INK_text: 'Țol pătrat',
  FTK_text: 'Picior pătrat',
  YDK_text: 'Yard pătrat',
  MIK_text: 'Milă pătrată',
  CMK_text: 'Centimetru pătrat',
  MTK_text: 'Metru pătrat',
  KMK_text: 'Kilometru pătrat',
  INQ_text: 'Țol cubic',
  MMQ_text: 'Milimetru cubic',
  FTQ_text: 'Picior cubic',
  CMQ_text: 'Centimetru cubic',
  OZA_text: 'Uncie lichidă',
  PT_text: 'Pint',
  QT_text: 'Cvart',
  MLT_text: 'Mililitru',
  ONZ_text: 'Uncie',
  LBR_text: 'Livre',
  STN_text: 'Tonă',
  GRM_text: 'Gram',
  KGM_text: 'Kilogram',
  TNE_text: 'Tonă',
  PS_text: 'Livre pe țol pătrat',
  MPA_text: 'Megapascal',
  C56_text: 'Newton pe milimetru pătrat',
  C62_text: 'Unu',
  NL_text: 'Încărcătură',
  MT_text: 'Suport',
  P1_text: 'Procent',
  CEL_text: 'Grad Celsius',
  FAH_text: 'Grad Fahrenheit',
  BLL_text: 'Baril',
  CLT_text: 'Centilitru',
  DLT_text: 'Decilitru',
  GLI_text: 'Galon imperial',
  '2U_text': 'Megagram',
  SA_text: 'Sac',
  '60_text': 'Procent greutate',
  BG_text: 'Pungă',
  SEC_text: 'Secundă',
  MIN_text: 'Minut',
  '64_text': 'Livre pe țol pătrat - Manometru',
  SP_text: 'Pachet raft',
  MMK_text: 'Milimetru pătrat',
  MTN_text: 'Tonă metrică',
  GT_text: 'Gigatonă',
  '/NL_text': 'Pe încărcătură',
  '/EA_text': 'Pe cantitate',
  '/H/ + h_text': 'Pe oră',
  '/YQ/ + YDQ_text': 'Pe yard cubic',
  '/MQ/ + MTQ_text': 'Pe metru cubic',
  '/MN/ + MIN_text': 'Pe minut',
  '/MT_text': 'Pe metru',
  DSG_text: 'Doza',
  '/C_text': 'Per 100 greutate',
  '64_2_text': 'Specific',
  MTQ: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  M3: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  LTR: `{value, plural,
    =0 {0 litri}
    one {1 litru}
    other {# litri}
  }`,
  TO: `{value, plural,
    =0 {0 tone}
    one {1 ton}
    other {# tone}
  }`,
  ITEM: `{value, plural,
    =0 {0 bucăți}
    one {1 bucată}
    other {# bucăți}
  }`,
  YDQ_short: `{value, plural,
    =0 {0 yd³}
    one {1 yd³}
    other {# yd³}
  }`,
  YDQ: `{value, plural,
    =0 {0 yarzi cubi}
    one {1 yard cubic}
    other {# yarzi cubi}
  }`,
  GLL: `{value, plural,
    =0 {0 galoane}
    one {1 galon}
    other {# galoane}
  }`,
  EA: `{value, plural,
    =0 {0 bucăți}
    one {1 bucată}
    other {# bucăți}
  }`,
  MIN: `{value, plural,
    =0 {0 minute}
    one {1 minută}
    other {# minute}
  }`,
  ACR: `{value, plural,
    =0 {0 acri}
    one {1 acru}
    other {# acri}
  }`,
  HUR: `{value, plural,
    =0 {0 ore}
    one {1 oră}
    other {# ore}
  }`,
  INH: `{value, plural,
    =0 {0 țoli}
    one {1 țol}
    other {# țoli}
  }`,
  FOT: `{value, plural,
    =0 {0 picioare}
    one {1 picior}
    other {# picioare}
  }`,
  YRD: `{value, plural,
    =0 {0 yarzi}
    one {1 yard}
    other {# yarzi}
  }`,
  MMT: `{value, plural,
    =0 {0 milimetri}
    one {1 milimetru}
    other {# milimetri}
  }`,
  CMT: `{value, plural,
    =0 {0 centimetri}
    one {1 centimetru}
    other {# centimetri}
  }`,
  MTR: `{value, plural,
    =0 {0 metri}
    one {1 metru}
    other {# metri}
  }`,
  SMI: `{value, plural,
    =0 {0 mile (mile statutare)}
    one {1 milă (milă statutară)}
    other {# mile (mile statutare)}
  }`,
  KMT: `{value, plural,
    =0 {0 kilometri}
    one {1 kilometru}
    other {# kilometri}
  }`,
  INK: `{value, plural,
    =0 {0 țoli pătrați}
    one {1 țol pătrat}
    other {# țoli pătrați}
  }`,
  FTK: `{value, plural,
    =0 {0 picioare pătrate}
    one {1 picior pătrat}
    other {# picioare pătrate}
  }`,
  YDK: `{value, plural,
    =0 {0 yarzi pătrați}
    one {1 yard pătrat}
    other {# yarzi pătrați}
  }`,
  MIK: `{value, plural,
    =0 {0 mile pătrate}
    one {1 milă pătrată}
    other {# mile pătrate}
  }`,
  CMK: `{value, plural,
    =0 {0 centimetri pătrați}
    one {1 centimetru pătrat}
    other {# centimetri pătrați}
  }`,
  MTK: `{value, plural,
    =0 {0 metri pătrați}
    one {1 metru pătrat}
    other {# metri pătrați}
  }`,
  KMK: `{value, plural,
    =0 {0 kilometri pătrați}
    one {1 kilometru pătrat}
    other {# kilometri pătrați}
  }`,
  INQ: `{value, plural,
    =0 {0 țoli cubi}
    one {1 țol cubic}
    other {# țoli cubi}
  }`,
  MMQ: `{value, plural,
    =0 {0 milimetri cubi}
    one {1 milimetru cubic}
    other {# milimetri cubi}
  }`,
  FTQ: `{value, plural,
    =0 {0 picioare cubi}
    one {1 picior cubic}
    other {# picioare cubi}
  }`,
  CMQ: `{value, plural,
    =0 {0 centimetri cubi}
    one {1 centimetru cubic}
    other {# centimetri cubi}
  }`,
  OZA: `{value, plural,
    =0 {0 uncii lichide}
    one {1 uncie lichidă}
    other {# uncii lichide}
  }`,
  PT: `{value, plural,
    =0 {0 pinți}
    one {1 pintă}
    other {# pinți}
  }`,
  QT: `{value, plural,
    =0 {0 curți}
    one {1 curtă}
    other {# curți}
  }`,
  MLT: `{value, plural,
    =0 {0 mililitri}
    one {1 mililitru}
    other {# mililitri}
  }`,
  ONZ: `{value, plural,
    =0 {0 uncii}
    one {1 uncie}
    other {# uncii}
  }`,
  LBR: `{value, plural,
    =0 {0 livre}
    one {1 liră}
    other {# livre}
  }`,
  STN: `{value, plural,
    =0 {0 tone}
    one {1 ton}
    other {# tone}
  }`,
  GRM: `{value, plural,
    =0 {0 grame}
    one {1 gram}
    other {# grame}
  }`,
  KGM: `{value, plural,
    =0 {0 kilograme}
    one {1 kilogram}
    other {# kilograme}
  }`,
  TNE: `{value, plural,
    =0 {0 tone}
    one {1 ton}
    other {# tone}
  }`,
  PS: `{value, plural,
    =0 {0 psi}
    one {1 psi}
    other {# psi}
  }`,
  MPA: `{value, plural,
    =0 {0 megapascali}
    one {1 megapascal}
    other {# megapascali}
  }`,
  C56: `{value, plural,
    =0 {0 newtoni pe mm²}
    one {1 newton pe mm²}
    other {# newtoni pe mm²}
  }`,
  C62: `{value, plural,
    =0 {0 unitate}
    one {1 unitate}
    other {# unități}
  }`,
  NL: `{value, plural,
    =0 {0 transporturi}
    one {1 transport}
    other {# transporturi}
  }`,
  MT: `{value, plural,
    =0 {0 plase}
    one {1 plasă}
    other {# plase}
  }`,
  P1: `{value, plural,
    =0 {0 procente}
    one {1 procent}
    other {# procente}
  }`,
  CEL: `{value, plural,
    =0 {0 grade Celsius}
    one {1 grad Celsius}
    other {# grade Celsius}
  }`,
  FAH: `{value, plural,
    =0 {0 grade Fahrenheit}
    one {1 grad Fahrenheit}
    other {# grade Fahrenheit}
  }`,
  BLL: `{value, plural,
    =0 {0 barili}
    one {1 baril}
    other {# barili}
  }`,
  CLT: `{value, plural,
    =0 {0 centilitri}
    one {1 centilitru}
    other {# centilitri}
  }`,
  DLT: `{value, plural,
    =0 {0 decilitri}
    one {1 decilitru}
    other {# decilitri}
  }`,
  GLI: `{value, plural,
    =0 {0 galoane}
    one {1 galon}
    other {# galoane}
  }`,
  '2U': `{value, plural,
    =0 {0 megagrame}
    one {1 megagram}
    other {# megagrame}
  }`,
  SA: `{value, plural,
    =0 {0 saci}
    one {1 sac}
    other {# saci}
  }`,
  60: `{value, plural,
    =0 {0 procent greutate}
    one {1 procent greutate}
    other {# procent greutate}
  }`,
  BG: `{value, plural,
    =0 {0 pungi}
    one {1 pungă}
    other {# pungi}
  }`,
  SEC: `{value, plural,
    =0 {0 secunde}
    one {1 secundă}
    other {# secunde}
  }`,
  64: `{value, plural,
    =0 {0 livre/țol² - manometru}
    one {1 liră/țol² - manometru}
    other {# livre/țol² - manometru}
  }`,
  SP: `{value, plural,
    =0 {0 pachete raft}
    one {1 pachet raft}
    other {# pachete raft}
  }`,
  MMK: `{value, plural,
    =0 {0 milimetri pătrați}
    one {1 milimetru pătrat}
    other {# milimetri pătrați}
  }`,
  MTN: `{value, plural,
    =0 {0 tone metrice}
    one {1 ton metric}
    other {# tone metrice}
  }`,
  GT: `{value, plural,
    =0 {0 gigatone}
    one {1 gigaton}
    other {# gigatone}
  }`,
  '/NL': `{value, plural,
    =0 {0 per transport}
    one {1 per transport}
    other {# per transport}
  }`,
  '/EA': `{value, plural,
    =0 {0 per cantitate}
    one {1 per cantitate}
    other {# per cantitate}
  }`,
  '/H/ + h': `{value, plural,
    =0 {0 per oră}
    one {1 per oră}
    other {# per oră}
  }`,
  '/YQ/ + YDQ': `{value, plural,
    =0 {0 per yard cubic}
    one {1 per yard cubic}
    other {# per yard cubic}
  }`,
  '/MQ/ + MTQ': `{value, plural,
    =0 {0 per metru cubic}
    one {1 per metru cubic}
    other {# per metru cubic}
  }`,
  '/MN/ + MIN': `{value, plural,
    =0 {0 per minut}
    one {1 per minut}
    other {# per minut}
  }`,
  '/MT': `{value, plural,
    =0 {0 per metru}
    one {1 per metru}
    other {# per metru}
  }`,
  DSG: `{value, plural,
    =0 {0 dozaj}
    one {1 dozaj}
    other {# dozaje}
  }`,
  '/C': `{value, plural,
    =0 {0 per 100 greutate}
    one {1 per 100 greutate}
    other {# per 100 greutate}
  }`,
  '64_2': `{value, plural,
    =0 {0 specific}
    one {1 specific}
    other {# specific}
  }`,
  LTR_short: `{value, plural,
  =0 {0 L}
  one {1 L}
  other {# L}
  }`,
  TO_short: `{value, plural,
  =0 {0 ton}
  one {1 ton}
  other {# ton}
}`,
  ITEM_short: `{value, plural,
  =0 {0 Items}
  one {1 Item}
  other {# Items}
}`,
  GLL_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  EA_short: `{value, plural,
  =0 {0 ea}
  one {1 ea}
  other {# ea}
}`,
  MIN_short: `{value, plural,
  =0 {0 min}
  one {1 min}
  other {# min}
}`,
  ACR_short: `{value, plural,
  =0 {0 ac}
  one {1 ac}
  other {# ac}
}`,
  HUR_short: `{value, plural,
  =0 {0 hr}
  one {1 hr}
  other {# hr}
}`,
  INH_short: `{value, plural,
  =0 {0 in}
  one {1 in}
  other {# in}
}`,
  FOT_short: `{value, plural,
  =0 {0 ft}
  one {1 ft}
  other {# ft}
}`,
  YRD_short: `{value, plural,
  =0 {0 yd}
  one {1 yd}
  other {# yd}
}`,
  MMT_short: `{value, plural,
  =0 {0 mm}
  one {1 mm}
  other {# mm}
}`,
  CMT_short: `{value, plural,
  =0 {0 cm}
  one {1 cm}
  other {# cm}
}`,
  MTR_short: `{value, plural,
  =0 {0 m}
  one {1 m}
  other {# m}
}`,
  SMI_short: `{value, plural,
  =0 {0 Miles (st mi)}
  one {1 Mile ((st mi)}
  other {# Miles ((st mi)}
}`,
  KMT_short: `{value, plural,
  =0 {0 km}
  one {1 km}
  other {# km}
}`,
  INK_short: `{value, plural,
  =0 {0 in²}
  one {1 in²}
  other {# in²}
}`,
  FTK_short: `{value, plural,
  =0 {0 ft²}
  one {1 ft²}
  other {# ft²}
}`,
  YDK_short: `{value, plural,
  =0 {0 yd²}
  one {1 yd²}
  other {# yd²}
}`,
  MIK_short: `{value, plural,
  =0 {0 mi²}
  one {1 mi²}
  other {# mi²}
}`,
  CMK_short: `{value, plural,
  =0 {0 cm²}
  one {1 cm²}
  other {# cm²}
}`,
  MTK_short: `{value, plural,
  =0 {0 m²}
  one {1 m²}
  other {# m²}
}`,
  KMK_short: `{value, plural,
  =0 {0 km²}
  one {1 km²}
  other {# km²}
}`,
  INQ_short: `{value, plural,
  =0 {0 in³}
  one {1 in³}
  other {# in³}
}`,
  MMQ_short: `{value, plural,
  =0 {0 mm³}
  one {1 mm³}
  other {# mm³}
}`,
  FTQ_short: `{value, plural,
  =0 {0 ft³}
  one {1 ft³}
  other {# ft³}
}`,
  CMQ_short: `{value, plural,
  =0 {0 cm³}
  one {1 cm³}
  other {# cm³}
}`,
  OZA_short: `{value, plural,
  =0 {0 fl oz}
  one {1 fl oz}
  other {# fl oz}
}`,
  PT_short: `{value, plural,
  =0 {0 pt}
  one {1 pt}
  other {# pt}
}`,
  QT_short: `{value, plural,
  =0 {0 qt}
  one {1 qt}
  other {# qt}
}`,
  MLT_short: `{value, plural,
  =0 {0 mL}
  one {1 mL}
  other {# mL}
}`,
  ONZ_short: `{value, plural,
  =0 {0 oz}
  one {1 oz}
  other {# oz}
}`,
  LBR_short: `{value, plural,
  =0 {0 lb}
  one {1 lb}
  other {# lb}
}`,
  STN_short: `{value, plural,
  =0 {0 ton}
  one {1 ton}
  other {# ton}
}`,
  GRM_short: `{value, plural,
  =0 {0 g}
  one {1 g}
  other {# g}
}`,
  KGM_short: `{value, plural,
  =0 {0 kg}
  one {1 kg}
  other {# kg}
}`,
  TNE_short: `{value, plural,
  =0 {0 t}
  one {1 t}
  other {# t}
}`,
  PS_short: `{value, plural,
  =0 {0 psi}
  one {1 psi}
  other {# psi}
}`,
  MPA_short: `{value, plural,
  =0 {0 mpa}
  one {1 mpa}
  other {# mpa}
}`,
  C56_short: `{value, plural,
  =0 {0 Newtons Per Square Millimeter}
  one {1 Newton Per Square Millimeter}
  other {# Newtons Per Square Millimeter}
}`,
  C62_short: `{value, plural,
  =0 {0 One}
  one {1 One}
  other {# One}
}`,
  NL_short: `{value, plural,
  =0 {0 Loads}
  one {1 Load}
  other {# Loads}
}`,
  MT_short: `{value, plural,
  =0 {0 Mats}
  one {1 Mat}
  other {# Mats}
}`,
  P1_short: `{value, plural,
  =0 {0 %}
  one {1 %}
  other {# %}
}`,
  CEL_short: `{value, plural,
  =0 {0 c}
  one {1 c}
  other {# c}
}`,
  FAH_short: `{value, plural,
  =0 {0 f}
  one {1 f}
  other {# f}
}`,
  BLL_short: `{value, plural,
  =0 {0 bbl}
  one {1 bbl}
  other {# bbl}
}`,
  CLT_short: `{value, plural,
  =0 {0 cL}
  one {1 cL}
  other {# cL}
}`,
  DLT_short: `{value, plural,
  =0 {0 dL}
  one {1 dL}
  other {# dL}
}`,
  GLI_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  '2U_short': `{value, plural,
  =0 {0 megagrame}
  one {1 megagram}
  other {# megagrame}
}`,
  SA_short: `{value, plural,
  =0 {0 saci}
  one {1 sac}
  other {# saci}
}`,
  '60_short': `{value, plural,
  =0 {0 % greutate}
  one {1 % greutate}
  other {# % greutate}
}`,
  BG_short: `{value, plural,
  =0 {0 pungi}
  one {1 pungă}
  other {# pungi}
}`,
  SEC_short: `{value, plural,
  =0 {0 sec}
  one {1 sec}
  other {# sec}
}`,
  '64_short': `{value, plural,
  =0 {0 psi - manometru}
  one {1 psi - manometru}
  other {# psi - manometru}
}`,
  SP_short: `{value, plural,
  =0 {0 pach. raft}
  one {1 pach. raft}
  other {# pach. raft}
}`,
  MMK_short: `{value, plural,
  =0 {0 milimetri pătrați}
  one {1 milimetru pătrat}
  other {# milimetri pătrați}
}`,
  MTN_short: `{value, plural,
  =0 {0 tone metrice}
  one {1 ton metric}
  other {# tone metrice}
}`,
  GT_short: `{value, plural,
  =0 {0 gigatone}
  one {1 gigaton}
  other {# gigatone}
}`,
  '/NL_short': `{value, plural,
  =0 {0 /transport}
  one {1 /transport}
  other {# /transport}
}`,
  '/EA_short': `{value, plural,
  =0 {0 /cantitate}
  one {1 /cantitate}
  other {# /cantitate}
}`,
  '/H/ + h_short': `{value, plural,
  =0 {0 /oră}
  one {1 /oră}
  other {# /oră}
}`,
  '/YQ/ + YDQ_short': `{value, plural,
  =0 {0 /yard cubic}
  one {1 /yard cubic}
  other {# /yard cubic}
}`,
  '/MQ/ + MTQ_short': `{value, plural,
  =0 {0 /m³}
  one {1 /m³}
  other {# /m³}
}`,
  '/MN/ + MIN_short': `{value, plural,
  =0 {0 /min}
  one {1 /min}
  other {# /min}
}`,
  '/MT_short': `{value, plural,
  =0 {0 /m}
  one {1 /m}
  other {# /m}
}`,
  DSG_short: `{value, plural,
  =0 {0 dozaj}
  one {1 dozaj}
  other {# dozaj}
}`,
  '/C_short': `{value, plural,
  =0 {0 /100 greutate}
  one {1 /100 greutate}
  other {# /100 greutate}
}`,
  '64_2_short': `{value, plural,
  =0 {0 specifici}
  one {1 specific}
  other {# specifici}
}`,
  mixIdLabel: 'ID amestec/Descriere',
  productIdLabel: 'ID produs/Descriere',
  orderedQtyLabel: 'Cantitate comandată',
  loadedQtyLabel: 'Cantitate încărcată',
  addedByCustomer: 'Adăugat de client',
  PRINTED: 'Biletat',
  LOADING_STARTED: 'Începere încărcare',
  LOADING_COMPLETE: 'Finalizare încărcare',
  TO_JOB: 'Plecare din fabrică',
  ARRIVE_JOB: 'Sosire pe șantier',
  UNLOADING: 'Începere descărcare',
  END_UNLOADING: 'Finalizare descărcare',
  LEAVE_JOB: 'Plecare de pe șantier',
  IN_YARD: 'În curte',
  WASHING: 'Spălare',
  END_WASHING: 'Sfârșit spălare',
  PUMPING_STARTED: 'Începere pompare',
  PUMPING_COMPLETE: 'Finalizare pompare',
  READY_TO_PUMP: 'Gata de pompare',
  FIRST_WCCONTACT: 'Primul contact apă-ciment',
  plantName: 'Nume fabrică',
  plantAddress: 'Adresă fabrică',
  loadingScheduleStart: 'Oră planificată încărcare',
  deliveryAddress: 'Adresă livrare',
  phoneNumber: 'Număr telefon',
  unloadingScheduleStart: 'Oră planificată descărcare (ETA)',
  agreedUnloading: 'Ore comandate descărcare',
  deliveryInformation: 'Informații livrare',
  next: 'Următorul',
  material: 'Material',
  loadingPoint: 'Punct încărcare',
  unloadingPoint: 'Punct descărcare',
  getDirections: 'Obține direcții',
  comment: 'Comentariu',
  sapDeliveryNumber: 'Număr livrare SAP (număr BCC)',
  salesOrderNumber: 'Număr comandă vânzare și linie articol',
  wcDateTime: 'Data și ora contact W/C',
  po: 'Număr comandă',
  orderedByName: 'Comandă făcută de',
  orderedByPhone: 'Comandă făcută pe telefon',
  resourceId: 'ID resursă',
  totalLoadedQty: 'Cantitate totală încărcată inclusiv acest transport',
  spacing: 'Spațiu pentru încărcare',
  deliveryFlow: 'Flux livrare',
  timeOnSite: 'Timp total pe șantier / timp descărcare comandat',
  salesText: 'Text vânzare (ID material)',
  strengthClass: 'Clasă rezistență',
  environmentExposure: 'Expunere mediu',
  metExposureClasses: 'Clase expunere',
  dmax: 'Dmax',
  standardCert: 'Standard (certificare)',
  workabilityTarget: 'Obiectiv lucrabilitate client',
  stoneQuality: 'Calitate piatră',
  sandQuality: 'Calitate nisip',
  targetWC: 'Raport țintă W/C din rețetă',
  controlClass: 'Clasă control',
  chlorideClass: 'Clasă cloruri',
  typeAndStrength1: 'Tip ciment și clasă rezistență 1',
  typeAndStrength2: 'Tip ciment și clasă rezistență 2',
  typeOfAddition: 'Tip aditiv',
  typeOfAdmixture: 'Tip adaos',
  orderedTemp: 'Temperatură comandată',
  fibers1: 'Tip și conținut fibre 1',
  fibers2: 'Tip și conținut fibre 2',
  calculatedMaturityTime: 'Timp maturitate calculat de la contact W/C',
  mixIdentity: 'Identitate amestec',
  grade: 'Clasă',
  mixType: 'Tip amestec',
  maxAggSize: 'Dimensiune maximă agregat',
  maxAggType: 'Tip maxim agregat',
  cementType: 'Tip ciment',
  admixtures: 'Adausuri',
  addmixDescription: 'Descriere adaos',
  slump: 'Tasare',
  minCementContent: 'Conținut minim ciment',
  maxWatCemRatio: 'Raport maxim apă/ciment',
  maxWaterToAdd: 'Apă maximă de adăugat',
  mortarMinWorkingLife: 'Durată minimă de lucru mortar',
  code: 'Cod',
  dcClass: 'dcClass',
  chloride: 'Cloruri',
  signedByHanson: 'Semnat de Hanson',
  warmStamp: 'Ștampilă caldă',
  coldStamp: 'Ștampilă rece',
  containsSikatard: 'Conține Sikatard',
  containsDelvo: 'Conține Delvo',
  generalDelivery: 'Informații generale livrare',
  materialInfo: 'Informații material',
  water: 'Apă',
  materialService: 'Material / Serviciu',
  returnedMaterial: 'Material returnat',
  returnedConcrete: 'Beton returnat',
  waterAdded: 'Apă adăugată',
  concreteOnTruck: 'Beton pe camion',
  concreteOnTruckUom: 'UOM implicit beton pe camion',
  reason: 'Motiv',
  customerAddedWater: 'Clientul a adăugat apă',
  addWater: 'Adaugă apă',
  addedAt: 'Adăugat la',
  addMaterialService: 'Adaugă material/serviciu',
  customerAddedProduct: 'Clientul a adăugat produs',
  addReturnedMaterial: 'Adaugă material returnat',
  leftover: 'Rest',
  submitAcceptance: 'Trimite acceptare',
  accepted: 'Acceptat',
  rejected: 'Respins',
  customerAcceptance: 'Acceptare',
  finalize: 'Finalizează',
  earlyAcceptance: 'Acceptare timpurie',
  materialSummary: 'Rezumat material',
  mix: 'Amestec',
  ordered: 'Comandat',
  loaded: 'Încărcătură livrare',
  totalOrdered: 'Cantitate totală comandată',
  loadedOrderQuantity: 'Cantitate încărcată comandată',
  loadedOrder: 'Comandă încărcată',
  driverComment: 'Comentariu șofer',
  driverCommentInternal: 'Comentariu șofer (Intern)',
  customerComment: 'Comentariu client',
  editComment: 'Editează comentariu',
  addComment: 'Adaugă comentariu',
  additionalInfo: 'Informații adiționale',
  onBoard: 'La bord',
  driver: 'Șofer',
  commentInstruction: 'Instrucțiuni comentariu',
  signatureInstruction: 'Semnătură client *',
  customerSignature: 'Semnătură client',
  general: 'General',
  status: 'Status',
  updateStatusTime: 'Update Status Time',
  delete: 'Șterge',
  cancel: 'Anulare',
  back: 'Înapoi',
  add: 'Adaugă',
  edit: 'Editează',
  done: 'Gata',
  ok: 'OK',
  decline: 'Refuz',
  Submit: 'Trimite',
  submit: 'Trimite',
  lastRefresh: 'Ultima actualizare',
  refreshEnabled: 'Activează actualizare',
  id: 'ID',
  name: 'Nume',
  invoiceable: 'Facturabil',
  provideSignature: 'Oferă semnătură',
  ticket: 'Bilet',
  details: 'Detalii',
  qrCode: 'Cod QR',
  driverAcceptanceReason: 'Motiv',
  driverAcceptance: 'Acceptare șofer',
  'payment-method': 'Metode plată',
  'add-payment-method': 'Adaugă metodă plată',
  'reason-code': 'Cod motiv',
  'add-reason-code': 'Adaugă cod motiv',
  'qr-code': 'Cod QR',
  'unloading-method': 'Metode descărcare',
  'add-unloading-method': 'Adaugă metodă descărcare',
  'driver-comment': 'Comentarii șofer',
  'add-driver-comment': 'Adaugă comentariu șofer',
  'driver-sellable': 'Vânzare șofer',
  vehicle: 'Vehicule',
  'add-vehicle': 'Adaugă vehicul',
  'vehicle-type': 'Tipuri vehicule',
  vehicleTypes: 'Tipuri vehicule',
  vehicleType: 'Tip vehicul',
  'add-vehicle-type': 'Adaugă tip vehicul',
  countries: 'Țări',
  country: 'Țară',
  type: 'Tip',
  uom: 'UOM',
  mandatory: 'Obligatoriu',
  qrTemplate: 'Șablon cod QR',
  includeMixInfo: 'Include informații amestec în cod QR',
  includeTicketEvents: 'Include evenimente bilet în cod QR',
  quantityField: 'Activează câmp cantitate',
  concreteOnTruckField: 'Activează câmp beton pe camion',
  materialOnTruckField: 'Activează câmp material pe camion',
  timeField: 'Activează câmp oră',
  reasonField: 'Activează câmp motiv',
  driverInstructions: 'Instrucțiuni pentru șofer',
  waitingForTicket: 'Așteptare bilet...',
  createTestTicketForTruck: 'Creează bilet test pentru camion',
  exceedsLoadedQuantity: 'Valoarea nu poate depăși cantitatea încărcată de {loadedQuantity}.',
  maxQuantity: 'Cantitate maximă',
  maxQuantityError: 'Cantitatea nu poate depăși maximul definit de {maxQty}',
  maxValueError: 'Valoarea nu poate depăși maximul definit de {maxQty}',
  minValueError: 'Valoarea nu poate fi mai mică decât minimul definit de {minQty}',
  notAuthorized: 'Neautorizat',
  enterTruckNumber: 'Introduceți numărul camionului',
  setTruckNumber: 'Setează număr camion',
  commentList: 'Listă comentarii',
  list: 'Listă',
  gridPreferences: 'Preferințe grilă',
  loadingUnloadingPoints: 'Puncte încărcare/descărcare',
  activity: 'Activitate',
  crn: 'Crn',
  update: 'Actualizează',
  CONCRETE: 'Beton',
  WATER: 'Apă',
  ADDITIVE: 'Aditiv',
  'submit-signature-button': 'Acceptă',
  'cancel-signature-button': 'Anulare',
  uomCode: 'UOM implicit',
  'product-type': 'Tipuri produse',
  'add-product-type': 'Adaugă tip produs',
  'add-product': 'Adaugă produs',
  'setup_driver-comment': 'Comentarii șofer',
  setup_product: 'Produse',
  'setup_product-type': 'Tipuri produse',
  'setup_qr-code': 'Cod QR',
  'setup_reason-code': 'Coduri motiv',
  'setup_unloading-method': 'Metode descărcare',
  'setup_entity-mt': 'Companie',
  setup_vehicle: 'Vehicule',
  'setup_vehicle-type': 'Tipuri vehicule',
  'setup_data-retentions': 'Retenție date',
  'add-data-retentions': 'Adaugă retenție date',
  'data-retentions': 'Retenție date',
  setup_carriers: 'Transportatori',
  'add-carriers': 'Adaugă transportatori',
  carriers: 'Transportatori',
  'setup_concrete-classes': 'Conformitate material',
  'add-concrete-classes': 'Adaugă conformitate material',
  'concrete-classes': 'Conformitate material',
  'setup_forms-and-waivers': 'Formulare și renunțări',
  'add-forms-and-waivers': 'Adaugă formulare și renunțări',
  'forms-and-waivers': 'Formulare și renunțări',
  companyFleet: 'Flotă companie',
  category: 'Categorie',
  interval: 'Interval',
  orders: 'Comenzi și bilete',
  '30days': '30 zile',
  '60days': '60 zile',
  '90days': '90 zile',
  '1year': '1 an',
  '3years': '3 ani',
  waterMandatory: 'Apă obligatorie',
  qrCodeTemplate: 'Șablon cod QR',
  waterConfig: 'Câmpuri opționale',
  waterProduct: 'Apă',
  waterProductType: 'Tip produs apă',
  defaultWaterProduct: 'Produs apă implicit',
  invalidTemplate: 'Șablon invalid',
  siteAddress: 'Adresă șantier',
  siteContactName: 'Nume contact șantier',
  siteContactPhoneNumber: 'Telefon contact șantier',
  'clear-signature-button': 'Șterge semnătura',
  customerCommentEnabled: 'Activează comentariu client',
  driverCommentEnabled: 'Activează comentariu șofer',
  driverCommentMaxCharacters: 'Lungime maximă',
  customerCommentMaxCharacters: 'Lungime maximă',
  timeZone: 'Fus orar',
  driverDidNotAdd: 'Șoferul nu a adăugat',
  noWaterAdded: 'Șoferul nu a adăugat',
  maxLineItems: 'Număr maxim de poziții',
  oneLineItem: 'Trebuie să aibă cel puțin 1 poziție',
  signatureSiteContact: 'Nume client',
  signatureSiteContactMandatory: 'Nume client *',
  ticketEvents: 'Evenimente bilet',
  hideEvent: 'Ascunde eveniment',
  editable: 'Editabil',
  ticketDetail: `Bilet #{value}`,
  statusTimes: 'Ore status',
  materialAndDeliveryInfo: 'Informații material și livrare',
  customerRejection: 'Respingere client',
  'submit-rejection-button': 'Trimite respingere',
  accept: 'Acceptă',
  reject: 'Respinge încărcătura',
  signature: 'Semnătură',
  'no-signature': 'Fără semnătură',
  unFinalizePassword: 'Parolă anulare finalizare',
  waterInWorkflow: 'Activează pasul apă în flux',
  multicountry: 'Multinațional',
  timestampAfterSequence: 'AVERTIZARE: Ora nu trebuie să fie înainte de marca temporară anterioară',
  timestampBeforeSequence: 'AVERTIZARE: Ora nu trebuie să fie după marca temporară următoare',
  noRestQuantity: 'Fără material returnat',
  returnedMaterialMandatory: 'Trebuie să interacționeze cu pasul material returnat',
  driverCommentMaxChars: 'Lungimea nu poate depăși maximul de {maxLength} caractere.',
  QrCodeEnabled: 'Activează cod QR',
  QrMethod_linkBased: 'Bazat pe link',
  QrMethod_contentBased:
    'Bazat pe conținut, NOTĂ: Codurile QR bazate pe conținut au limitări de caractere care pot cauza probleme peste 1024 caractere.',
  QrMethod_contentBasedWarning: 'NOTĂ: Acest cod QR are {amount} caractere care pot fi nelegibile pe unele telefoane.',
  returnedMaterialInWorkflow: 'Activează pasul material returnat în flux',
  materialServiceInWorkflow: 'Activează pasul material/serviciu în flux',
  totalPumpedQuantity: 'Cantitate totală pompată',
  concrete: 'Beton',
  materialComplianceEnabled: 'Activează conformitate material',
  pumpStatusTimes: 'Ore status pompă',
  pollingInterval: 'Interval verificare (secunde)',
  tenSecs: 'Intervalul trebuie să fie de cel puțin 10 secunde',
  materialCompliance: 'Conformitate material',
  materialCompliance_notFound: 'Conformitate material negăsită',
  materialCompliance_outOfRange_warning: 'Valoarea introdusă este în afara intervalului de toleranță al clasei de beton.',
  consistenceValue: 'Consistență - tasare',
  consistenceIsCompliant: 'Consistența respectă BS8500-2',
  airContentValue: 'Conținut aer',
  airContentIsCompliant: 'Conținutul de aer respectă BS8500-2',
  consistenceIsCompliantShort: 'Consistența respectă',
  airContentIsCompliantShort: 'Conținutul de aer respectă',
  compliance: 'Conformitate material cu BS8500-2',
  termsAndConditionsEnabled: 'Activează formular termeni și condiții',
  termsAndConditions: 'Termeni și condiții',
  damageWaiverEnabled: 'Activează formular renunțare la daune',
  damageWaiver: 'Renunțare la daune',
  damageWaiverAcknowledged: 'Renunțare la daune recunoscută',
  dynamicWaiver: 'Renunțare dinamică',
  dynamicWaiverEnabled: 'Activează formular renunțare dinamică',
  ticketListEnabled: 'Activează listă bilete',
  clearTicketAfterSubmission: 'Șterge bilet după trimitere',
  keepTicketOpenAfterSubmission: 'Păstrează biletul deschis după trimitere',
  displayTicketList: 'Afișează listă bilete',
  supportedLanguages: 'Limburi acceptate',
  allow: 'Permite',
  default: 'Implicit',
  isCertificationLossTriggerForReason: 'Motiv pentru notă pierdere certificare',
  isCertificationLossTriggerForProduct: 'Produs notă pierdere certificare',
  translations: 'Traduceri',
  family_name: 'Nume de familie',
  given_name: 'Prenume',
  email: 'Email',
  role: 'Rol',
  inviteUser: 'Invită utilizator',
  carrier: 'Transportator',
  emailOrPhoneNumber: 'Email',
  usersEditor: 'Editor utilizatori',
  verifyPassword: 'Confirmă parola',
  verificationCode: 'Cod verificare',
  register: 'Înregistrare',
  registerInstructions: 'Vă rugăm completați acest formular pentru a finaliza înregistrarea.',
  'password-requirements':
    'Parola trebuie să aibă cel puțin 8 caractere, 1 majusculă, 1 minusculă, 1 cifră și 1 caracter special.',
  passwordMinCharacters: 'Parola trebuie să conțină 8 sau mai multe caractere.',
  passwordMaxCharacters: 'Parola nu poate conține mai mult de 99 caractere.',
  passwordLowerCase: 'Parola trebuie să conțină cel puțin 1 literă mică.',
  passwordUpperCase: 'Parola trebuie să conțină cel puțin 1 literă mare.',
  passwordNumber: 'Parola trebuie să conțină cel puțin 1 cifră.',
  passwordSpecialCharacter: 'Parola trebuie să conțină cel puțin 1 caracter special.',
  passwordsDontMatch: 'Parolele nu coincid!',
  success: 'Succes!',
  'registration-success': 'Înregistrarea a fost finalizată cu succes.',
  'post-registration-instructions': 'Ați finalizat procesul de înregistrare. Acum vă puteți autentifica.',
  createDate: 'Dată creare',
  customerPo: 'Număr comandă client',
  specification: 'Specificație',
  description: 'Descriere',
  classType: 'Tip clasă',
  minimumValue: 'Valoare minimă',
  maximumValue: 'Valoare maximă',
  TrackIt: 'TrackIt',
  trackIt3PContext: 'TrackIt 3P context',
  inviteLanguage: 'Limbă invitație',
  truckNumber: 'Număr camion',
  adverseTemperature:
    'Temperatura ambiantă la momentul amestecării nu permite garantarea faptului că betonul va fi în intervalul 5-35°C conform EN 206.',
  environmentalNote:
    'Această încărcătură conține un agent de mediu care nu depășește 0,03% din greutatea betonului. Apa care conține acest material pentru fabricarea betonului respectă BS EN 1008.',
  unloadingMethodEnabled: 'Activează metodă descărcare',
  warrantyVoided: 'Garanție material anulată',
  materialWarrantyVoidedEnabled:
    'Când se folosește produs notă pierdere certificare sau cod produs și motiv, afișează notă la momentul semnăturii.',
  'setup_templates-mt': 'Șabloane',
  copyFrom: 'Copiază din...',
  copy: 'copie',
  users: 'Utilizatori',
  setup: 'Configurare',
  driverExperience: 'Experiența șoferului',
  ticketList: 'Listă bilete',
  content: 'Conținut',
  WARNINGS: 'Avertizări',
  TERMS: 'Termeni',
  DAMAGE: 'Daune',
  ADDITIONALWAIVER: 'Renunțare suplimentară',
  DYNAMICWAIVER: 'Renunțare dinamică',
  source: 'Sursă',
  sensorUnable: 'Senzorul nu poate determina cantitatea rămasă.',
  PROBE: 'Sondă',
  DRIVER: 'Șofer',
  DRS: 'DRS',
  waterReleaseFormEnabled: 'Activează formular eliberare apă',
  waterRelease: 'Eliberare apă',
  waterReleaseMandatory: 'Eliberare apă *',
  waterReleaseAcknowledged: 'Eliberare apă recunoscută',
  'assessment-risk': 'Evaluare risc',
  'setup_assessment-risk': 'Evaluare risc',
  'add-assessment-risk': 'Adaugă evaluare risc',
  enterRecipientsButton: 'Introduceți destinatar(i)',
  recipientsInstructions: 'Introduceți email, separat prin virgulă',
  enter: 'Introdu',
  invalidEmailAddress: 'adresă de email invalidă',
  personalDataPolicy:
    'Prin introducerea datelor personale în acest formular, confirmați că aveți permisiunile necesare pentru partajarea acestor date',
  subcategory: 'Subcategorie',
  isRequired: 'Obligatoriu',
  riskAssessmentEnabled: 'Activează evaluare risc',
  riskAssessment: 'Evaluare risc',
  yes: 'Da',
  no: 'Nu',
  sourceOptionsSensors: 'Opțiuni sursă (senzori)',
  sourceDcm: 'DCM',
  sourceProbe: 'Sondă',
  availableCustomValues: 'Valori personalizate disponibile',
  ERR_CODE__DUPLICATE: 'Duplicat',
  ERR_CODE__DEFAULT_VALUE: 'Există deja o valoare implicită',
  ERR_CODE__EXISTING_FORM: 'Există deja un formular activ pentru acest vehicul și tip',
  availableValues: 'Valori disponibile',
  pump: 'Pompă',
  DanskName: 'Nume danez',
  GermanName: 'Nume german',
  EnglishName: 'Nume englez',
  BritainName: 'Nume britanic',
  SpanishName: 'Nume spaniol',
  FrenchName: 'Nume francez',
  NederlandsName: 'Nume neerlandez',
  NorskName: 'Nume norvegian',
  SvenskaName: 'Nume suedez',
  ItalianName: 'Nume italian',
  PolishName: 'Nume polonez',
  DanskNameDefault: 'Nume danez (implicit)',
  GermanNameDefault: 'Nume german (implicit)',
  EnglishNameDefault: 'Nume englez (implicit)',
  BritainNameDefault: 'Nume britanic (implicit)',
  SpanishNameDefault: 'Nume spaniol (implicit)',
  FrenchNameDefault: 'Nume francez (implicit)',
  NederlandsNameDefault: 'Nume neerlandez (implicit)',
  NorskNameDefault: 'Nume norvegian (implicit)',
  SvenskaNameDefault: 'Nume suedez (implicit)',
  ItalianNameDefault: 'Nume italian (implicit)',
  PolishNameDefault: 'Nume polonez (implicit)',
  DanskDescription: 'Descriere daneză',
  GermanDescription: 'Descriere germană',
  EnglishDescription: 'Descriere engleză',
  BritainDescription: 'Descriere britanică',
  SpanishDescription: 'Descriere spaniolă',
  FrenchDescription: 'Descriere franceză',
  NederlandsDescription: 'Descriere neerlandeză',
  NorskDescription: 'Descriere norvegiană',
  SvenskaDescription: 'Descriere suedeză',
  ItalianDescription: 'Descriere italiană',
  PolishDescription: 'Descriere poloneză',
  DanskDescriptionDefault: 'Descriere daneză (implicit)',
  GermanDescriptionDefault: 'Descriere germană (implicit)',
  EnglishDescriptionDefault: 'Descriere engleză (implicit)',
  BritainDescriptionDefault: 'Descriere britanică (implicit)',
  SpanishDescriptionDefault: 'Descriere spaniolă (implicit)',
  FrenchDescriptionDefault: 'Descriere franceză (implicit)',
  NederlandsDescriptionDefault: 'Descriere neerlandeză (implicit)',
  NorskDescriptionDefault: 'Descriere norvegiană (implicit)',
  SvenskaDescriptionDefault: 'Descriere suedeză (implicit)',
  ItalianDescriptionDefault: 'Descriere italiană (implicit)',
  PolishDescriptionDefault: 'Descriere poloneză (implicit)',
  DanskContent: 'Conținut danez',
  GermanContent: 'Conținut german',
  EnglishContent: 'Conținut englez',
  BritainContent: 'Conținut britanic',
  SpanishContent: 'Conținut spaniol',
  FrenchContent: 'Conținut francez',
  NederlandsContent: 'Conținut neerlandez',
  NorskContent: 'Conținut norvegian',
  SvenskaContent: 'Conținut suedez',
  ItalianContent: 'Conținut italian',
  PolishContent: 'Conținut polonez',
  DanskContentDefault: 'Conținut danez (implicit)',
  GermanContentDefault: 'Conținut german (implicit)',
  EnglishContentDefault: 'Conținut englez (implicit)',
  BritainContentDefault: 'Conținut britanic (implicit)',
  SpanishContentDefault: 'Conținut spaniol (implicit)',
  FrenchContentDefault: 'Conținut francez (implicit)',
  NederlandsContentDefault: 'Conținut neerlandez (implicit)',
  NorskContentDefault: 'Conținut norvegian (implicit)',
  SvenskaContentDefault: 'Conținut suedez (implicit)',
  ItalianContentDefault: 'Conținut italian (implicit)',
  PolishContentDefault: 'Conținut polonez (implicit)',
  DanskCategory: 'Categorie daneză',
  GermanCategory: 'Categorie germană',
  EnglishCategory: 'Categorie engleză',
  BritainCategory: 'Categorie britanică',
  SpanishCategory: 'Categorie spaniolă',
  FrenchCategory: 'Categorie franceză',
  NederlandsCategory: 'Categorie neerlandeză',
  NorskCategory: 'Categorie norvegiană',
  SvenskaCategory: 'Categorie suedeză',
  ItalianCategory: 'Categorie italiană',
  PolishCategory: 'Categorie poloneză',
  DanskCategoryDefault: 'Categorie daneză (implicit)',
  GermanCategoryDefault: 'Categorie germană (implicit)',
  EnglishCategoryDefault: 'Categorie engleză (implicit)',
  BritainCategoryDefault: 'Categorie britanică (implicit)',
  SpanishCategoryDefault: 'Categorie spaniolă (implicit)',
  FrenchCategoryDefault: 'Categorie franceză (implicit)',
  NederlandsCategoryDefault: 'Categorie neerlandeză (implicit)',
  NorskCategoryDefault: 'Categorie norvegiană (implicit)',
  SvenskaCategoryDefault: 'Categorie suedeză (implicit)',
  ItalianCategoryDefault: 'Categorie italiană (implicit)',
  PolishCategoryDefault: 'Categorie poloneză (implicit)',
  DanskSubcategory: 'Subcategorie daneză',
  GermanSubcategory: 'Subcategorie germană',
  EnglishSubcategory: 'Subcategorie engleză',
  BritainSubcategory: 'Subcategorie britanică',
  SpanishSubcategory: 'Subcategorie spaniolă',
  FrenchSubcategory: 'Subcategorie franceză',
  NederlandsSubcategory: 'Subcategorie neerlandeză',
  NorskSubcategory: 'Subcategorie norvegiană',
  SvenskaSubcategory: 'Subcategorie suedeză',
  ItalianSubcategory: 'Subcategorie italiană',
  PolishSubcategory: 'Subcategorie poloneză',
  DanskSubcategoryDefault: 'Subcategorie daneză (implicit)',
  GermanSubcategoryDefault: 'Subcategorie germană (implicit)',
  EnglishSubcategoryDefault: 'Subcategorie engleză (implicit)',
  BritainSubcategoryDefault: 'Subcategorie britanică (implicit)',
  SpanishSubcategoryDefault: 'Subcategorie spaniolă (implicit)',
  FrenchSubcategoryDefault: 'Subcategorie franceză (implicit)',
  NederlandsSubcategoryDefault: 'Subcategorie neerlandeză (implicit)',
  NorskSubcategoryDefault: 'Subcategorie norvegiană (implicit)',
  SvenskaSubcategoryDefault: 'Subcategorie suedeză (implicit)',
  ItalianSubcategoryDefault: 'Subcategorie italiană (implicit)',
  PolishSubcategoryDefault: 'Subcategorie poloneză (implicit)',
  priorSignatures: 'Semnături anterioare',
  damageWaiverSignature: 'Semnătură renunțare la daune',
  waterReleaseSignature: 'Semnătură eliberare apă',
  errors,
  themes,
  isPDFRecipientListEnable: 'Activează lista de destinatari PDF pe ecranul semnăturii client',
  isRejectLoadsEnable: 'Activează respingerea încărcăturilor după sosire',
  rejectLoad_returnedMaterial: 'Buton flux material returnat',
  rejectLoad_returnedAndFinalize: 'Butoane material returnat și finalizare',
  driverRejection: 'Respinge încărcătura',
  submitRejection: 'Trimite respingere',

  costAndPaymentsSummary: 'Rezumat cost și plăți',
  groupCostPriorTotal: 'Cost total anterior livrare',
  subtotal: 'Subtotal',
  tax: 'Taxă',
  remainingBalance: 'Sold rămas',
  paymentAmount: 'Sumă plată',
  total: 'Total',
  paymentMethod: 'Metodă plată',
  paymentProducts: 'Produse',
  unitPrice: 'Preț unitar',
  amount: 'Sumă',
  otherPaymentMethod: 'Altă metodă plată',
  method: 'Metodă',
  paymentOptions: 'Opțiuni plată',
  typeAdditionalInfo: 'Introduceți informații adiționale aici',
  COD: 'Plată la livrare',
  AMEX: 'American Express',
  CASH: 'Numerar',
  CHECK: 'Cec',
  'CREDIT CARD': 'Card de credit',
  ACCOUNT: 'Cont deschis',
  UNKNOWN: 'Necunoscut',
  remainingMaterial: 'Material rămas',
  splitLoad: 'Încărcătură divizată - Multiple',
  isEnablePaymentAndCostWorkflows: 'Activează fluxuri plată și cost',

  // DOT Workflow
  dotWorkflow: 'Detalii lot',
  inspectorSignature: 'Semnătură inspector',
  producerSignature: 'Semnătură producător',
  addedItems: 'Articole adăugate',
  producerSignatureContact: 'Nume producător',
  inspectorSignatureContact: 'Nume inspector',

  //
  airTempValue: 'Temperatură aer',
  concreteTempValue: 'Temperatură beton',
  cylinderNumber: 'Număr cilindru',
  materialOnTruck: 'Material pe camion',
  waterLocation: 'Locație apă',
  waterAtPlant: 'Apă la fabrică (gl)',
  waterAtJobsite: 'Apă pe șantier (gl)',
  totalActualWater: 'Apă efectivă totală',
  timeDischarged: 'Oră descărcare',
  // news
  ingredient: 'Ingredient',
  mcFac: 'MCFac',
  absFac: 'ABSFAC',
  od: 'OD',
  abs: 'ABS',
  ssd: 'SSD',
  freeMst: 'Mst gratuit',
  cydsTarg: 'CYDS TARG',
  target: 'Țintă',
  actual: 'Efectiv',
  freWat: 'Apă liberă',
  trim: 'Ajustare',
  batchInformation: 'Informații lot',
  numberOfBatches: 'Număr loturi',
  totalWater: 'Apă totală',
  designWater: 'Apă proiect',
  toAdd: 'De adăugat',
  designWC: 'Proiect W/C',
  waterCement: 'Apă / Ciment',
  waterInTruck: 'Apă în camion',
  adjustWater: 'Ajustează apă',
  trimWater: 'Ajustează apă',
  plantWeather: 'Vreme fabrică',
  rh: 'RH',
  observationTime: 'Oră observare',
  address: 'Adresă',
  plant: 'Fabrică',
  sp: 'S.P. #',
  beginTime: 'Oră început',
  mixDesc: 'Descriere amestec',
  qtyOder: 'Cant. comandă',
  poTag: 'PO #',
  bridge: 'Pod #',
  volume: 'Volum',
  truckTag: 'Camion #',
  qtyDelivered: 'Cant. livrată',
  qtyOrder: 'Cant. comandă',
  job: 'Șantier #',
  batchRecord: 'Înregistrare lot',
  mixID: 'ID amestec',
  loads: 'Încărcături',
  isDot: 'DOT',
  onlyPrimaryLineItem: 'Doar linia principală',
  tolStatus: 'Status TOL',
  lastUpdate: 'Ultima actualizare',
  driverClickedFinalize: 'Șoferul a apăsat Finalizare',
  autoSubmit: 'Trimitere automată',
  noTaxInformationIsAvailable: 'Informații despre taxe indisponibile',
  retryPullTaxInformation: 'Actualizare date taxe',
  var: '% Var',
  designQTY: 'Cant. proiect',
  batched: 'Loturi',
  moisture: 'Umiditate',
  actualWater: 'Apă efectivă',
  moisturePercent: '% umiditate',
  freeWater: 'Apă liberă',
  reset: 'Resetare',
  'at-plant': 'La fabrică',
  'at-job': 'Pe șantier',
  viewTickets: 'Vizualizare bilete',
  viewSchedule: 'Vizualizare program',
  viewActiveTicket: 'Vizualizare bilet activ',
  dateSelector_last_week: 'Săptămâna trecută',
  dateSelector_yesterday: 'Ieri',
  dateSelector_tomorrow: 'Mâine',
  dateSelector_today: 'Azi',
  gridHeader_created: 'Creat',
  gridHeader_customerStatus: 'Status client',
  gridHeader_ticketId: 'Bilet',
  gridHeader_vehicle: 'Vehicul',
  gridFooter_retrieved: 'Preluate',
  gridFooter_loading: 'Se încarcă...',
  general: {
    ...CAI_MATERIAL.i18n['en-US'].general,
  },
  component: {
    ...CAI_MATERIAL.i18n['en-US'].component,
  },
  attachments: 'Atașamente',
  priorOrderCostTotal: 'Total anterior',
  priorOrderPaymentTotal: 'Plăți anterioare',
  orderShippedCostTotal: 'Total comandă',
  orderShippedBalance: 'Sold comandă',
  ticketSubtotal: 'Subtotal bilet',
  ticketTax: 'Taxă bilet',
  ticketTotal: 'Total bilet',
  driverId: 'ID șofer',
  ticketStatus: 'Stare bilet',
  voided: 'Anulat',
  ticketVoidedNotification: 'Acest bilet a fost anulat.',
  ticketed: 'Emis',
};
